"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rssHost = exports.gisHost = void 0;
var gisHost;
(function (gisHost) {
    gisHost["ALPHA"] = "https://gis.sit.sf-express.com:45001";
    gisHost["PROD"] = "https://gis.sf-express.com";
})(gisHost = exports.gisHost || (exports.gisHost = {}));
var rssHost;
(function (rssHost) {
    rssHost["ALPHA"] = "http://gis-int.intsit.sfdc.com.cn:1080/rp/v2/api";
    rssHost["PROD"] = "http://gis-int.int.sfdc.com.cn:1080/rp/v2/api";
})(rssHost = exports.rssHost || (exports.rssHost = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-geo/dist/common/config.js
// module id = +QTb
// module chunks = 1